module.exports = __webpack_public_path__ + "app/components/feedback/details.view.html";